import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FlipCameraIosIcon(props: IconProps) {
    return <Icon {...props} iconKey={"flip_camera_ios"}/>
}
